import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TeamMemberNameFilter extends Component {
    state = {
        teamLists: [],
        teamValue: '',
    };
    componentDidMount(){
        //this._get_team();
        this.getTeamMembers([]);
    }
    resetTeamMemberFilter() {
        this.setState({
            teamValue: [],
        });
    }
    getTeamMembers(teamIds){
        axios.post(
            config.get('API_URL') + '/filters/service_reports/get-teams-member/',
            { team_ids: teamIds },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }
        ).then(response => {
            let teamLists = [];

            if(Array.isArray(response.data)) {
                response.data.forEach(item => {
                    teamLists.push({
                        value: item.agentid,
                        label: item.agentname
                    });
                });
            }

            this.setState({
                teamLists,
                teamValue: []   // reset selection
            });
        });
    }
    _get_team(){
        axios.get(config.get('API_URL')+'/filters/service_reports/get-teams-member/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((teamname, index) => {
                    this.state.teamLists.push({value: teamname.agentid, label: teamname.agentname})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    changeTeam(optionSelected) {
        let teamArray = [];
        if (optionSelected.length > 0) {
            optionSelected.map((item) => {
                teamArray.push(item.value);
            });
        } else {
            teamArray = '';
        }

        this.props.onSelectTeamMember(optionSelected, teamArray);

        this.setState({
            teamValue: optionSelected,
        });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes
                name="team_member"
                isMulti
                value={this.state.teamValue}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeTeam.bind(this)}
                options={this.state.teamLists}
                placeholderButtonLabel="Select [Team Member]"
            />
        );
    }
}

export default TeamMemberNameFilter;
